import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Input, LabelText, SubmitButton, FlexContainer, LeftBackButtonText, H1Text, Hr, Text, Img, InputWrapper } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import queryString from 'query-string';
import { API, axiosLoginInstance, BASE_URLS } from "../../api";
import { SWIREPAY_URL, TOKENS, US_FILING_GID } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import ArrowIcon from "../../assets/imgs/forwardarrow.svg";
import OpenIcon from "../../assets/imgs/eyeopen.svg";
import HiddenIcon from "../../assets/imgs/eyeclose.svg";

type Props = {
    history: {
        push: Function,
    },
}
const SetupPassword = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState();
    const [readOnly, setReadOnly] = useState([]);
    const [showerrorMessage, setShowErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState(false);
    const [passwordMatch, setPasswordMatch] = useState(false);
    const publicKey = localStorage.getItem('publicKey');
    const [parentAccGid, setParentAccGid] = useState(null);

    useEffect(() => {
        getAccount();
    }, []);
    
    const getAccount = async () => {
        try {
            const config = {
                headers: {
                    'x-api-key': publicKey,
                }
            };
            const { data } = await API.get(BASE_URLS.GET_ACCOUNT, config);
            if (data?.entity?.gid) {
                setParentAccGid(data?.entity?.gid);
            };
        } catch (e) {
            setShowErrorMessage(true);
            setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
        }
    };

    const { handleSubmit, errors, control } = useForm();
    const onSubmit = async (data) => {
        setPasswordMatch(false);
        if (data.newpassword === data.confirmpassword) {
            try {
                const { data: { entity } } = await axiosLoginInstance.post(BASE_URLS.RESPOND_CHALLENGE, {
                    challengeName: 'NEW_PASSWORD_REQUIRED',
                    session: localStorage.getItem(TOKENS.SESSION_TOKEN),
                    challengeResponses: {
                        NEW_PASSWORD: `${data.newpassword}`,
                        USERNAME: `${localStorage.getItem('email')}`,
                    },
                });
                if (entity && entity.token) {
                    localStorage.setItem(TOKENS.ACCESS_TOKEN, entity?.token?.accessToken);
                    localStorage.setItem(TOKENS.REFRESH_TOKEN, entity?.token?.refreshToken);
                    setSuccess(true);
                }
                localStorage.removeItem(TOKENS.SESSION_TOKEN);
            } catch (e) {
                if (e.response.status !== 401) {
                    setShowErrorMessage(true);
                    setErrorMessage(e && e.data ? e.data.message : 'Unable to process request. Please try again later');
    
                } else if (e.response.status === 401) {
                    props.history.push({
                        pathname: `/temporarypassword`,
                        setErrorMessage: { errorMsg: 'Unable to process request. Please do login again' },
                    });
                }
            }
        } else if (data.newpassword !== data.confirmpassword) {
            setPasswordMatch(true);
        }
        
    }

    useEffect(() => {
        if (success && parentAccGid === US_FILING_GID) {
            props.history.replace('/us-filing-partner-business');
        } else if (success) {
            props.history.replace('/partner-business');
        }
    }, [success]);

    const isValidate = (data:string) => {
        const matchPassword = control.getValues().newpassword;
        if (data !== matchPassword) {
            return "Must match password typed above";
        }
    }


    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <LeftBackButtonText
                            onClick={() => { props.history.push(`/temppassword`); }}
                        >
                            Back
                      </LeftBackButtonText>
                        <H1Text>
                            Configure Payments
                      </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                >
                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        ACCOUNT SETUP
                    </H1Text>
                    <Text className="px-1 px-md-4" paddingBottom="8px">
                        Setup a new password
                    </Text>
                    <Hr />
                    <div className="px-1 px-md-4 mt-2">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <LabelText className="mt-4 mb-2">
                                New Password
                        </LabelText>
                            <InputWrapper marginBottom="0px" borderRadius="4px" width='298px'>
                                <Controller
                                    defaultValue={""}
                                    control={control}
                                    color={errors.newpassword ? "red" : "inherit"}
                                    border="0px !important"
                                    name="newpassword"
                                    placeholder="New Password"
                                    rules={{
                                        required: 'Password is required',
                                        pattern: {
                                            value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
                                            message: 'The password is invalid',
                                        },
                                    }}
                                    as={<Input
                                        style={{
                                            marginTop: "0",
                                            marginBottom: "0px",
                                            width: "268px",
                                        }}
                                        type={showPassword ? "text" : "password"} readOnly={readOnly && readOnly.includes("newpassword")} />}
                                />
                                <Img verticalAlign='middle' onClick={() => setShowPassword(!showPassword)} src={showPassword ? OpenIcon : HiddenIcon} />
                            </InputWrapper>
                            <ErrorMessage
                                errors={errors}
                                name="newpassword"
                                render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                            />
                            <Text className="mt-3 mb-2" fontSize="12px" marginTop="4px" marginBottom="0px" style={{ width: '292px' }}>
                                New password should have atleast 8 characters in combination of uppercase, lowercase, number, also atleast one special character.
                            </Text>
                            <LabelText className="mt-4 mb-2">
                                Confirm New Password
                        </LabelText>
                            <InputWrapper marginBottom="0px" borderRadius="4px" width='298px'>
                                <Controller
                                    defaultValue={""}
                                    control={control}
                                    color={errors.confirmpassword ? "red" : "inherit"}
                                    border="0px !important"
                                    name="confirmpassword"
                                    placeholder="Confirm New Password"
                                    rules={{
                                        required: 'Password is required',
                                    }}
                                    as={<Input style={{
                                        marginTop: "0",
                                        marginBottom: "0px",
                                        width: "268px",
                                    }}
                                        type={confirmPassword ? "text" : "password"} readOnly={readOnly && readOnly.includes("confirmpassword")} />}
                                />
                                <Img verticalAlign='middle' onClick={() => setConfirmPassword(!confirmPassword)} src={confirmPassword ? OpenIcon : HiddenIcon} />
                            </InputWrapper>
                            <ErrorMessage
                                errors={errors}
                                name="confirmpassword"
                                render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                )}
                            />
                            {passwordMatch && <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Password and Confirm Password should match</Text>}
                            {showerrorMessage && <PaymentError header={errorMessage} message={null} />}
                            <div>
                                <SubmitButton
                                    style={{ width: '292px' }}
                                    type="submit"
                                >Next <Img verticalAlign='middle' src={ArrowIcon} /></SubmitButton>
                            </div>
                            {showerrorMessage && <PaymentError header={errorMessage} message={null} />}
                        </form>
                    </div>
                </FlexContainer>
            </>
        } />
    )
};

export default SetupPassword;
